import { z } from 'zod';
import {
  ascSortDirectionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';
import { preprocessAsBoolean } from 'src/components/form/zod-utilities';

export const storageLocationsPageParamsSchema = z
  .object({
    sortColumn: z.string().default('name'),
    sortDirection: ascSortDirectionSchema,
    favoritesOnly: z.preprocess(preprocessAsBoolean, z.boolean().default(true)),
    name: z.string().nullable().default(null),
    refId: z.string().nullable().default(null),
    ssoShortName: z.string().nullable().default(null),
  })
  .merge(getPaginationSchema());
